var React = require('react');

function LayoutIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"75","height":"75","rx":"12","fill":"#E8F1FB","key":0}),React.createElement("rect",{"x":"12.5","y":"12.5","width":"50","height":"10.4167","fill":"#428FDA","key":1}),React.createElement("rect",{"width":"15.625","height":"36.4583","transform":"matrix(-1 0 0 1 28.125 26.0416)","fill":"#114E8B","key":2}),React.createElement("rect",{"x":"31.25","y":"26.0416","width":"31.25","height":"16.6667","fill":"#1669BA","key":3}),React.createElement("rect",{"x":"31.25","y":"45.8334","width":"31.25","height":"16.6667","fill":"#1669BA","key":4})]);
}

LayoutIcon.defaultProps = {"width":"75","height":"75","viewBox":"0 0 75 75","fill":"none"};

module.exports = LayoutIcon;

LayoutIcon.default = LayoutIcon;
